// extracted by mini-css-extract-plugin
export default {"TextLink":"utils_TextLink__iNcaj","SmallMarginTop":"utils_SmallMarginTop__aD2Lm"};